module.exports = __webpack_public_path__ + "static/media/nvidia-logo.6808bdb2.png";